import React from 'react'
import Autosuggest from 'react-autosuggest'
import { get } from '../../../util/api'

const theme = {
    container: {
        position: 'relative',
    },
    input: {},
    inputFocused: {
        outline: 'none',
    },
    inputOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    suggestionsContainer: {
        display: 'none',
    },
    suggestionsContainerOpen: {
        display: 'block',
        position: 'relative',
        top: 0,
        width: '100%',
        border: '1px solid rgb(231, 235, 238)',
        backgroundColor: '#fff',
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '13px',
        borderBottomLeftRadius: 3,
        borderBottomRightRadius: 3,
        zIndex: 1000,
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    suggestion: {
        cursor: 'pointer',
        padding: '5px 10px',
    },
    suggestionHighlighted: {
        backgroundColor: 'rgb(231, 235, 238)',
    },
}


const getSuggestionValue = suggestion => {
    return suggestion.firstName + ' ' + suggestion.lastName
}

const renderSuggestion = suggestion => (
    <div>
        {suggestion.firstName + ' ' + suggestion.lastName + ' ' + suggestion.zip + ' ' + suggestion.city}
    </div>
)

class CustomerSuggest extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            value: props.currentCustomer ? getSuggestionValue(props.currentCustomer) : '',
            suggestions: [],
        }
        this.onChange = this.onChange.bind(this)
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    }

    componentWillReceiveProps (newProps) {
        this.setState({
            value: newProps.currentCustomer ? getSuggestionValue(newProps.currentCustomer) : '',
        })
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        })
    };

    onSuggestionsFetchRequested = ({ value }) => {
        if (!value) {
            this.setState({
                suggestions: [],
            })
            return
        }

        get('/api/customer/find-by-name-pattern?pattern=' + value)
            .then(resultList => {
                this.setState({
                    suggestions: resultList,
                })
            }).catch(error => {
                this.setState({
                    suggestions: [],
                })
            })
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        })
    };

    onSuggestionSelected (event, data) {
        this.props.onChangeCustomer(data.suggestion)
    }

    render () {
        const { value, suggestions } = this.state

        const inputProps = {
            placeholder: 'Choose Customer',
            value: value,
            onChange: this.onChange,
            className: 'form-control',
            // onBlur: this.props.onBlur,
            style: {
                zIndex: 10,
            },
        }

        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                onSuggestionSelected={this.onSuggestionSelected}
                theme={theme}
                inputProps={inputProps}
            />
        )
    }
}

export default CustomerSuggest



// WEBPACK FOOTER //
// ./src/modules/customer/component/CustomerSuggest.js